import { ImagePublicFileId } from '../image/image-public-file-id'
import React from 'react'
import { AwardDto } from 'src/dao/core-dao'
import { cn } from 'src/lib/utils'

const awardNameToClassMap: Record<string, string> = {
  Bronze: 'bg-bronze',
  Silver: 'bg-mist',
  Gold: 'bg-gold',
}

export const ProfileProgrammeAwardsCard = ({ programmeAward }: { programmeAward: AwardDto }): React.ReactElement => {
  const awardName = programmeAward?.award.name
  const scoreBgClass = awardName ? awardNameToClassMap[awardName] ?? '' : ''

  return (
    <div className="relative bg-[rgba(217,217,217,0.2)] border border-bright-grey h-fit p-[10px] px-5 rounded-md">
      <div
        className={cn(
          'absolute top-5 right-5 w-[30px] h-[30px] rounded-lg flex justify-center items-center text-secondary-gray font-roboto-condensed-medium text-sm font-semibold leading-[15px] tracking-[-0.5px]',
          scoreBgClass,
        )}
      >
        {programmeAward.count ?? 0}
      </div>
      <ImagePublicFileId fileId={programmeAward?.award.imagePublicFileId} className="block w-[70px] h-20 my-3 mx-auto mb-7" />
      <h3 className="text-center text-ivory text-lg font-semibold leading-[13px] font-roboto-condensed-medium">
        {programmeAward?.award.name}
      </h3>
    </div>
  )
}
